import { Component, Input, OnInit } from '@angular/core';
import { IonIcon, IonTabButton } from '@ionic/angular/standalone';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { notificationsOutline, search } from 'ionicons/icons';

import { CommonModule } from '@angular/common';
import { FreightIconComponent } from '@app/shared/components/icons/freight-icon/freight-icon.component';
import { HomeIconComponent } from '@app/shared/components/icons/home-icon/home-icon.component';
import { NotificationBadgeComponent } from "../../../../../../shared/components/icons/notification-badge/notification-badge.component";
import { UserIconComponent } from '@app/shared/components/icons/user-icon/user-icon.component';
import { addIcons } from 'ionicons';

@Component({
    selector: 'app-tabs-carrier',
    templateUrl: './tabs-carrier.component.html',
    styleUrls: ['./tabs-carrier.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        IonTabButton,
        HomeIconComponent,
        RouterLink,
        RouterLinkActive,
        IonIcon,
        FreightIconComponent,
        UserIconComponent,
        NotificationBadgeComponent
    ]
})
export class TabsCarrierComponent implements OnInit {
  @Input() notificationNumber: number = 6;
  constructor() {}

  ngOnInit() {
    addIcons({ search, notificationsOutline });
  }

  resetBadge(){
    this.notificationNumber = 0;
  }
}
